import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { FullScreenLoader } from 'components/ds/modals';
// import { usePageTracker } from 'lib/hooks/use-page-tracker';
import { StreakInterstitial } from 'components/ui/streak-interstitial';
import { QueryMessageDispatcher } from 'components/account/query-message';

// for both the signed-in and anonymous app screens (everything outside of auth and admin screens)
export const AppRouteLayout = ({
  /// this allows us to have the signed layout, but different design layout
  component: Component = null /*required now*/,
}) => {
  return (
    <Component>
      <React.Suspense fallback={<FullScreenLoader />}>
        <QueryMessageDispatcher />
        <Outlet />
      </React.Suspense>
      <StreakInterstitial />
    </Component>
  );
};
